"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCountries = void 0;
var http_1 = require("../../http/http");
var service_1 = __importDefault(require("../service"));
var getCountries = function (language) {
    return (0, http_1.create)(service_1.default.baseUrl, {
        headers: service_1.default.getDefaultHeaders(),
    }).get("/templates/".concat(language, "/countries"))
        .then(function (_a) {
        var data = _a.data;
        return Object.entries(data).map(function (country) { return ({
            codeISO: country[0],
            name: country[1],
        }); });
    });
};
exports.getCountries = getCountries;
exports.default = exports.getCountries;
